// mutations
const ADMIN_TURNS_ALL = (state, adminTurns) => {
  if (adminTurns.code === 1) {
    state.adminTurns = adminTurns.data
    state.status = 'success'
  } else {
    alert(adminTurns.message)
    state.status = 'error'
  }
}

const ADMIN_TURNS_FORM = (state, adminTurns) => {
  if (adminTurns.code === 1) {
    state.adminTurns = adminTurns.data
    state.status = 'success'
  } else {
    alert(adminTurns.message)
    state.status = 'error'
  }
}

const ADMIN_TURNS_SHOW = (state, adminTurns) => {
  if (adminTurns.code === 1) {
    state.adminTurns = adminTurns.data
    state.status = 'success'
  } else {
    alert(adminTurns.message)
    state.status = 'error'
  }
}

const ADMIN_TURNS_CREATE = (state, adminTurns) => {
  if (adminTurns.code === 1) {
    state.adminTurns = adminTurns.data
    state.status = 'success'
    alert(adminTurns.message)
  } else {
    alert(adminTurns.message)
    state.status = 'error'
  }
}

const ADMIN_TURNS_UPDATE = (state, adminTurns) => {
  if (adminTurns.code === 1) {
    state.adminTurns = adminTurns.data
    state.status = 'success'
    alert(adminTurns.message)
  } else {
    alert(adminTurns.message)
    state.status = 'error'
  }
}

const ADMIN_TURNS_DELETE = (state, adminTurns) => {
  if (adminTurns.code === 1) {
    state.adminTurns = adminTurns.data
    state.status = 'success'
    alert(adminTurns.message)
  } else {
    alert(adminTurns.message)
    state.status = 'error'
  }
}

export default {
  ADMIN_TURNS_ALL,
  ADMIN_TURNS_FORM,
  ADMIN_TURNS_SHOW,
  ADMIN_TURNS_CREATE,
  ADMIN_TURNS_UPDATE,
  ADMIN_TURNS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/turns/mutations.js